(() => {
  var ProductMultipleVariantSelect = class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectedVariants = [];
      this.submit = this.querySelector(`#AddToCart[type="button"]`);
      this.current_variant_configuration = JSON.parse(this.querySelector('[data-current-variants]').innerText);
      this.allowMultiselect = this.querySelector(
        'input[name="allowMultiselect"]'
      );
      this.masterSelector = document.getElementById(this.getAttribute("form-id")).id;
      this.selectItems = this.querySelectorAll(
        ".color-swatch__radio, .block-swatch__radio"
      );
      this.productVariants = this.querySelector("product-variants");
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.submit?.addEventListener("click", this.handleSubmit.bind(this));
      if (this.allowMultiselect) {
        this.allowMultiselect.addEventListener(
          "click",
          this.handleAllowMultiselect.bind(this)
        );
      }
      window.addEventListener("content:onloaded", () => {
        window.addEventListener("variant:changed", this.handleChange.bind(this));
      });
      
      if (this.dataset.isQuickView == "true") {
        this.selectedVariants.push({
          id: this.querySelector(`input[name="id"]`).value
        });
        window.addEventListener("variant:changed", this.handleChange.bind(this));
      }
    }

    async handleSubmit(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.submit.setAttribute("disabled", "disabled");
      this.submit.setAttribute("aria-busy", "true");
      let body = {
        items: [],
      };
      this.selectedVariants.forEach((item) => {
        let discount_input = document.querySelector(`input[name="properties[${item.id}][_discount]"`);
        let graduated_prices_input = document.querySelector(`input[name="properties[${item.id}][_graduated_prices]"`);
        let is_promotional_discount = document.querySelector(`input[name="properties[${item.id}][_is_promotional_discount]"`);
        let hash_input = document.querySelector(`input[name="properties[${item.id}][_hash]"`);
        let token_input = document.querySelector(`input[name="properties[${item.id}][_token]"`);
        let msg_conditional_input = document.querySelector(`input[name="properties[${item.id}][_msg_conditional]"`);
        let msg_graduated_input = document.querySelector(`input[name="properties[${item.id}][_msg_graduated]"`);
        let msg_promotional_input = document.querySelector(`input[name="properties[${item.id}][_msg_promotional]"`);
        body.items.push({
          id: item.id,
          quantity: parseInt(this.quantityInput.value),
          properties: {
            _discount: discount_input ? discount_input.value : '0',
            _graduated_prices: graduated_prices_input ? graduated_prices_input.value : '',
            _is_promotional_discount: is_promotional_discount ? is_promotional_discount.value : 'false',
            _hash: hash_input ? hash_input.value : '',
            _token: token_input ? token_input.value : '',
            _msg_conditional: msg_conditional_input ? msg_conditional_input.value : 'Conditional discount',
            _msg_graduated: msg_graduated_input ? msg_graduated_input.value : 'Graduated discount',
            _msg_promotional: msg_promotional_input ? msg_promotional_input.value : 'Promotional discount',
          }
        });
      });
      const response = await fetch(
        `${window.themeVariables.routes.cartAddUrl}.js`,
        {
          body: JSON.stringify(body),
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            'Accept': `application/json`,
            "X-Requested-With": "XMLHttpRequest",
          },
        }
      );
      this.submit.removeAttribute("disabled");
      this.submit.removeAttribute("aria-busy");
      const responseJson = await response.json();
      if (response.ok) {
        this.dispatchEvent(
          new CustomEvent("variant:added", {
            bubbles: true,
            detail: {
              variant: responseJson.hasOwnProperty("items")
                ? responseJson["items"][0]
                : responseJson,
            },
          })
        );
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
          async (response2) => {
            const cartContent = await response2.json();
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:updated", {
                bubbles: true,
                detail: {
                  cart: cartContent,
                },
              })
            );
            cartContent["sections"] = responseJson["sections"];
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartContent,
                  openMiniCart:
                    window.themeVariables.settings.cartType === "drawer" &&
                    this.closest(".drawer") === null,
                },
              })
            );
          }
        );
      }
      this.dispatchEvent(
        new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: response.ok ? "success" : "error",
            error: responseJson["description"] || "",
          },
        })
      );
    }

    handleAllowMultiselect(e) {
      this.productVariants.setAttribute(
        "data-multi-variant",
        e.target.checked ? "true" : "false"
      );
      this.selectItems.forEach((element) => {
        element.setAttribute("type", e.target.checked ? "checkbox" : "radio");
      });
      window.dispatchEvent(
        new Event("variant:multiselect:changed", { bubbles: true })
      );
      this.clear();
    }

    handleChange(e) {
      let isCurrentTarget = this.current_variant_configuration.variant_ids.some(id => id == e.detail.variant.id);
      if (!isCurrentTarget) {
        return;
      }
      this.submit.removeAttribute("disabled");
      var url = new URL(window.location);
      url.searchParams.set(`variant`, e.detail.variant.id);
      window.history.pushState({}, '', url);
      if (this.dataset.isQuickView == "true") {
        this.selectedVariants = [];
      }
      let multiselect = this.querySelector('input[name="allowMultiselect"]');
      if (multiselect && multiselect.checked == false || multiselect == undefined) {
        this.selectedVariants = [];
      }
      if (e.detail.deselect == undefined) {
        this.selectedVariants.push(e.detail.variant);
      } else {
        const variantItemIndex = this.selectedVariants.findIndex(
          (obj) => obj.id == e.detail.variant.id
        );
        let selectVariant = this.selectedVariants[variantItemIndex];
        if (variantItemIndex > -1) {
          this.selectedVariants.splice(variantItemIndex, 1);
        }
        if (this.selectedVariants.length == 0) {
          this.masterSelector.dispatchEvent(new CustomEvent('change'));
          this.masterSelector.dispatchEvent(new CustomEvent('variant:changed', {
            bubbles: true,
            detail: { variant: selectVariant }
          }));
        }
      }
    }

    clear() {
      this.selectedVariants = [];
      if (this.selectItems.length) {
        this.selectItems.forEach((element) => {
          if (element.checked) {
            element.checked = false;
          }
        });
        this.selectItems[0].click();
        var url = new URL(window.location);
        let defaultVariant = url.searchParams.get(`variant`);
        var isVariantSelected = this.selectedVariants.some(variant => variant.id == defaultVariant);
        if (!isVariantSelected) {
          this.selectedVariants.push({id: url.searchParams.get(`variant`)});
        }
      }
    }
  };

  window.customElements.define(
    "product-multiple-variants",
    ProductMultipleVariantSelect
  );
})();
